const PERIODS = [
  { id: "daily", label: "D" },
  { id: "weekly", label: "W" },
  { id: "monthly", label: "M" },
  { id: "quarterly", label: "Q" },
  { id: "yearly", label: "Y" },
];

export const PERIOD_LABELS = {
  daily: "Daily",
  weekly: "Weekly",
  monthly: "Monthly",
  quarterly: "Quarterly",
  yearly: "Yearly",
};

export default function PeriodToggle({ value, onChange, className = "" }) {
  return (
    <div className={`period-toggle ${className}`} role="tablist" aria-label="Time period">
      {PERIODS.map((p) => (
        <button
          key={p.id}
          type="button"
          role="tab"
          aria-selected={value === p.id}
          className={`period-toggle-btn ${value === p.id ? "active" : ""}`}
          onClick={() => onChange?.(p.id)}
          title={PERIOD_LABELS[p.id]}
        >
          {p.label}
        </button>
      ))}
    </div>
  );
}
